// -----------------------------------------------------------------------------
// Script for map with regions
// -----------------------------------------------------------------------------

function mapRegion() {

  var description = $('.region-map__info');
  var map = $('.region-map__content').offset();

  $('.map_show_title').hover(function () {
    description.finish().fadeIn('slow');
    description.html($(this).attr('id'));
  }, function () {
    description.finish().fadeOut('slow');
  });

  $('.region-map-hover').on('mousemove', function (e) {

    description.css({
      left: e.pageX - map.left,
      top: e.pageY - map.top - 30
    });

  });

}